module.exports = __webpack_public_path__ + "img/logo_easy.57a45e37.png";